import { render } from "./IrivhToffee.vue?vue&type=template&id=ccb027b4"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/IrivhToffee.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ccb027b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ccb027b4', __exports__)) {
    api.reload('ccb027b4', __exports__)
  }
  
  module.hot.accept("./IrivhToffee.vue?vue&type=template&id=ccb027b4", () => {
    api.rerender('ccb027b4', render)
  })

}


export default __exports__